app.constant('appConfig', {
  URL: 'https://dashboard.perf.sh',
  API_URL: 'https://api.perf.sh',
  INTERCOM_APP_ID: 'glnfol5p'
})
